import { useEffect, useState } from "react";

export const useResendCooldown = (initialTime = 60) => {
  const [cooldown, setCooldown] = useState(0);
  const [isResending, setIsResending] = useState(false);

  useEffect(() => {
    if (cooldown > 0) {
      const timer = setTimeout(() => setCooldown(cooldown - 1), 1000);
      return () => clearTimeout(timer);
    }
  }, [cooldown]);

  const startCooldown = () => {
    setCooldown(initialTime);
  };

  const canResend = cooldown === 0 && !isResending;

  return {
    cooldown,
    isResending,
    setIsResending,
    startCooldown,
    canResend,
  };
};